import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks';

/**
 * Smart redirect component that sends users to the correct dashboard
 * based on their user_type (superadmin vs county admin)
 */
export const DashboardRedirect = () => {
  const { user } = useAuth();
  const token = localStorage.getItem('auth_token');

  // If not logged in, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If user data not loaded yet, show nothing (prevents flash)
  if (!user) {
    return null;
  }

  // Redirect based on user_type (primary method)
  if (user.user_type === 'superadmin') {
    return <Navigate to="/superadmin/dashboard" replace />;
  }

  if (user.user_type === 'county') {
    return <Navigate to="/dashboard" replace />;
  }

  // Fallback: check roles
  const userRoles = user.roles?.map((r: any) => r.name) || [];
  if (userRoles.includes('Super Admin')) {
    return <Navigate to="/superadmin/dashboard" replace />;
  }

  // Default to county admin dashboard
  return <Navigate to="/dashboard" replace />;
};
